import { inject, Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ClassroomHeaderModalComponent } from "src/app/features/classroom/classroom-header-modal/classroom-header-modal.component";
import { ClassroomSupportModalComponent } from "src/app/features/classroom/classroom-support-modal/classroom-support-modal.component";
import { ProfileModalComponent } from "../profile-modal/profile-modal.component";
import { SettingsModalComponent } from "../settings-modal/settings-modal.component";

export type ClassroomSection = "header" | "support";

@Injectable({
  providedIn: "root",
})
export class ProfileService {
  private modalService = inject(NgbModal);

  openProfileModal() {
    const modalRef = this.modalService.open(ProfileModalComponent, {
      size: "lg",
      keyboard: true,
      backdrop: "static",
    });

    return modalRef.result;
  }

  openSettingsModal() {
    const modalRef = this.modalService.open(SettingsModalComponent, {
      size: "lg",
      keyboard: true,
    });

    return modalRef.result;
  }

  openClassroomModal(section: ClassroomSection) {
    const component = section === "header"
      ? ClassroomHeaderModalComponent
      : ClassroomSupportModalComponent;

    const modalRef = this.modalService.open(component, {
      size: "lg",
      keyboard: true,
      backdrop: "static",
    });

    return modalRef.result;
  }
}
